import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "reports-menu-root bc-2" }
const _hoisted_2 = { class: "resolution-selector-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "actions"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_5 = { class: "date" }

import { ref, watch, PropType } from 'vue'
import moment from 'moment'
import DatePicker from '@/components/common/DatePicker.vue'
import TimeSeeker from '@/components/common/TimeSeeker.vue'
import ResolutionSelector, { RESOLUTIONS } from './ResolutionSelector.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  showResolution: {
    type: Boolean,
    default: true,
    required: false,
  },

  showAdminBack: {
    type: Boolean,
    default: false,
    required: false,
  },

  defaultResolution: {
    type: String,
    default: RESOLUTIONS.HOUR,
    required: false,
  },

  defaultDate: {
    type: Date as PropType<Date>,
    default: moment().startOf('day').toDate(),
    required: false,
  },

  isShowSummary: {
    type: Boolean,
    default: false,
    required: false,
  },

  viewType: {
    type: String,
  },
},
  emits: ['show-summary', 'hide-summary', 'change-resolution', 'change-date', 'change-station-id'],
  setup(__props, { emit }) {

const props = __props





const resolution = ref<string>(props.defaultResolution)
const targetDate = ref<Date>(props.defaultDate)
const stationId = ref<string | undefined>()

const move = (direction: string) => {
  let moveAmount = 1
  let unit: 'minute' | 'hour' | 'day' | 'month' | 'year'
  const sign = direction === 'prev' ? -1 : 1

  if (resolution.value === RESOLUTIONS.HOUR) {
    unit = 'day'
  } else if (resolution.value === RESOLUTIONS.CAMERA_MIN) {
    moveAmount = 5
    unit = 'minute'
  } else if (resolution.value === RESOLUTIONS.CAMERA_HOUR) {
    unit = 'hour'
  } else if (resolution.value === RESOLUTIONS.MINUTE) {
    moveAmount = 5
    unit = 'minute'
  } else if (resolution.value === RESOLUTIONS.DAY || resolution.value === RESOLUTIONS.WEATHER) {
    unit = 'day'
  } else if (resolution.value === RESOLUTIONS.RUISEKI) {
    unit = 'month'
  } else if (resolution.value === RESOLUTIONS.MONTH) {
    unit = 'month'
  } else if (resolution.value === RESOLUTIONS.YEAR) {
    unit = 'year'
  } else if (resolution.value === RESOLUTIONS.HALF_DAY) {
    moveAmount = 12
    unit = 'hour'
  } else {
    moveAmount = 2
    unit = 'hour'
  }

  const newTime = moment(targetDate.value).add(sign * moveAmount, unit)

  if (newTime.isBefore(moment())) {
    targetDate.value = newTime.toDate()
  }
}

const movePrev = () => {
  move('prev')
}

const moveToday = () => {
  const now = moment().toDate()

  targetDate.value = now
}

const moveNext = () => {
  move('next')
}

const showSummary = () => {
  emit('show-summary')
}

const hideSummary = () => {
  emit('hide-summary')
}

watch(
  () => resolution.value,
  value => emit('change-resolution', value)
)

watch(
  () => targetDate.value,
  value => emit('change-date', value)
)

watch(
  () => stationId.value,
  value => emit('change-station-id', value)
)

watch(
  () => props.defaultResolution,
  () => (resolution.value = props.defaultResolution)
)

watch(
  () => props.defaultDate,
  () => (targetDate.value = props.defaultDate)
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "left"),
    _createElementVNode("div", _hoisted_2, [
      (__props.showResolution)
        ? (_openBlock(), _createBlock(ResolutionSelector, {
            key: 0,
            modelValue: resolution.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resolution).value = $event)),
            class: "hide-sp"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    (__props.showAdminBack)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/admin/menu",
            class: "actions-item"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([__props.isShowSummary ? 'show-summary' : '', "calendar-controller"])
    }, [
      _renderSlot(_ctx.$slots, "center"),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(DatePicker, {
          modelValue: targetDate.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((targetDate).value = $event)),
          resolution: resolution.value
        }, null, 8, ["modelValue", "resolution"])
      ]),
      _createVNode(TimeSeeker, {
        onPrev: movePrev,
        onToday: moveToday,
        onNext: moveNext,
        resolution: resolution.value
      }, null, 8, ["resolution"]),
      (__props.showResolution && ['day', 'month'].includes(resolution.value))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: showSummary,
            class: "btn-change-summary show hide-pc"
          }, " 集計値 "))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        onClick: hideSummary,
        class: "btn-change-summary back hide-pc"
      }, "戻る")
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})